import {
    useUserByProfileId,
    useUserByChatId,
    CHAT_ID_SOURCE,
    USER_ID_SOURCE,
} from '@bizzabo/entities';

type Source = typeof CHAT_ID_SOURCE | typeof USER_ID_SOURCE | '';

const useBusinessCardUser = (eventId: number, showId: string | number, source: Source) => {
    const { data: userByProfileId = null, isLoading: isUserByProfileIdLoading } =
        useUserByProfileId({
            eventId,
            userProfileId: showId,
            options: { enabled: source === USER_ID_SOURCE && !!showId },
        });
    const { data: userByChatId = null, isLoading: isUserByChatIdLoading } = useUserByChatId({
        eventId,
        chatId: showId,
        options: { enabled: source === CHAT_ID_SOURCE && !!showId },
    });
    const user = userByProfileId || userByChatId;
    const isLoading = isUserByProfileIdLoading || isUserByChatIdLoading;

    return { user, isLoading };
};

export default useBusinessCardUser;
